var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlay2Sm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1761px",
    height: "1227px",
    viewBox: "0 0 1761 1227",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.2031837%",
    y1: "64.9149328%",
    x2: "79.3919483%",
    y2: "29.4087923%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DCAD3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91ACF3",
    stopOpacity: 0.5,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "url(#linearGradient-1)",
    points: "1171.199 0.0925047438 1760.96868 0.0925047438 589.927648 1227 0.157969639 1227"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay2Sm);
export default __webpack_public_path__ + "static/media/overlay2-sm.929bf95e94454fb0845208ad4eab7e95.svg";
export { ForwardRef as ReactComponent };